import { render, staticRenderFns } from "./ColorProductsShopsInput.vue?vue&type=template&id=e9e1f0e4&scoped=true&"
import script from "./ColorProductsShopsInput.vue?vue&type=script&lang=js&"
export * from "./ColorProductsShopsInput.vue?vue&type=script&lang=js&"
import style0 from "./ColorProductsShopsInput.vue?vue&type=style&index=0&id=e9e1f0e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9e1f0e4",
  null
  
)

export default component.exports